module.exports = __webpack_public_path__ + "img/wrap-login.8bc9cc13.png";